import React from "react";

export default function PortalStub({ name }: { name: string }) {
  return (
    <div className="card">
      <h2>{name} Portal（占位页）</h2>
      <p className="muted">
        这是一个占位路由，用来证明：单个 Vite SPA 可以承载五端入口（/、/crm、/admin、/tenant、/owner）。
        后续你可以按 M1/M2 规划，把这里替换成真实业务页面或拆分成多仓/多 Pages 项目。
      </p>

      <div className="card">
        <h3>下一步建议（M0 → M1）</h3>
        <ol>
          <li>把 UI 原型/设计稿映射到路由结构（优先 Tenant/Owner 的核心闭环）。</li>
          <li>把 OpenAPI 生成类型接入（npm run api:gen），形成端到端契约联调。</li>
          <li>接入 Auth：/me + /auth/refresh 的“静默续期”逻辑（Cookie 同源）。</li>
        </ol>
      </div>
    </div>
  );
}
